export const BROWSER_FINGERPRINT_COOKIE_NAME = 'avfx_browser_fingerprint';
export const ANALYTICS_SEARCH_RESULTS_BUFFER_THRESHOLD = 16;
